// extracted by mini-css-extract-plugin
module.exports = {"slider":"ValueSlider_slider__1thOU"};